import { Component, Input } from "@angular/core";
import { DialogComponentBase } from "apps/portal/src/app/shared/components/dialog/dialog.component";
import { Dialog } from "primeng/dialog";
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";

@Component({
    selector: "app-image-dialog",
    templateUrl: "./image-dialog.component.html",
    imports: [Dialog, SafeHtmlPipe],
})
export class ImageDialogComponent extends DialogComponentBase {
    @Input() imageClass: string = "";

    imageName: string;
    imagePreview: string;

    create(name: string, imagePreview: string): void {
        this.imageName = name;
        this.imagePreview = imagePreview;
        this.openDialog();
    }
}
